import { storageKeys } from '@/app/constants/storageKeys';
import { storage } from '@/app/storage';

function isSafeLocalRedirect(route: string): boolean {
  return route.startsWith('/') && !route.includes('//') && route != '/';
}

function getAfterAuthRoute() {
  const lastRoute = storage.take(storageKeys.REDIRECT_AFTER_AUTH);
  return isSafeLocalRedirect(lastRoute) ? lastRoute : '/inicio';
}

export { getAfterAuthRoute, isSafeLocalRedirect };
